import type { Machine } from '@couch/shared';

/** One or two short lines describing what the machine computes with. */
export function hardwareLines(machine: Machine): string[] {
  const hw = machine.hardware;
  if (!hw) return ['Hardware not reported yet'];
  if (hw.gpu.kind === 'mps') {
    return [[hw.cpu, hw.gpu.cores && `${hw.gpu.cores}-core GPU`, `${hw.ramGb} GB unified memory`].filter(Boolean).join(' · ')];
  }
  const cpu = `${hw.cpu} · ${hw.ramGb} GB RAM`;
  if (hw.gpu.kind === 'cuda') return [`${hw.gpu.name} · ${hw.gpu.vramGb ?? '?'} GB VRAM`, cpu];
  return ['No GPU — ComfyUI runs on the CPU (slow)', cpu];
}

export function versionsLine(machine: Machine): string {
  return [machine.comfyuiVersion && `ComfyUI ${machine.comfyuiVersion}`, machine.agentVersion && `agent ${machine.agentVersion}`]
    .filter(Boolean).join(' · ');
}

export function lastSeen(iso: string | null): string {
  if (!iso) return 'never connected';
  return `last seen ${new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}`;
}

export const OS_LABEL: Readonly<Record<Machine['os'], string>> = Object.freeze({ macos: 'macOS', windows: 'Windows', linux: 'Linux' });

/** What to do about an offline machine: a pod Couch made is started here (doc 59), other cloud machines at the provider. */
export function offlineHint(machine: Machine): string {
  if (machine.cloudPodId) return 'Offline — start it here (RunPod panel on its page).';
  return machine.hardware?.cloud ? 'Offline — start it in your provider\'s console.' : 'Offline — switch it on; the agent starts at login.';
}
